import React from "react";

import { TextField } from "@repo/design-system";
import classNames from "classnames";
import { Controller } from "react-hook-form";

import { PasswordVisibilityToggle } from "./PasswordVisibilityToggle";
import { usePasswordVisibility } from "./hooks";
import { IFormTextareaFieldProps } from "./interfaces.ts";

export const FormInputField: React.FC<IFormTextareaFieldProps> = ({
  control,
  name,
  inputType,
  placeholder,
  className,
  label,
  isDisabled,
  autoFocus,
  description,
  descriptionClassName = "",
  hideErrorMessage = false,
  wrapperClassName = "mb-2",
  onChange,
  onInput,
  onKeyDown,
  icon,
  appendIcon,
}) => {
  const { isVisible, isPasswordField, toggleVisibility, resolvedInputType } =
    usePasswordVisibility(inputType);

  return (
    <div className={`${wrapperClassName} w-full`}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          const hasError = !!fieldState.error;
          return (
            <>
              <TextField
                aria-label={label?.toString() || name}
                isDisabled={isDisabled}
                autoFocus={autoFocus}
                onFocus={(e) => {
                  const el = e.currentTarget;
                  setTimeout(() => {
                    el.scrollIntoView({ block: "center", behavior: "smooth" });
                  }, 300);
                }}
                {...field}
                label={label}
                type={resolvedInputType}
                inputClassName={classNames(
                  "placeholder:text-contentQuartenary",
                  className,
                )}
                descriptionClassName={descriptionClassName}
                placeholder={placeholder}
                isInvalid={hasError}
                description={description}
                errorMessage={
                  !hideErrorMessage ? fieldState.error?.message : undefined
                }
                aria-invalid={hasError}
                onChange={(val) => {
                  field.onChange(val);
                  onChange?.(val);
                }}
                onKeyDown={onKeyDown}
                onInput={onInput}
                icon={icon}
                appendIcon={
                  isPasswordField && !appendIcon ? (
                    <PasswordVisibilityToggle
                      isVisible={isVisible}
                      onToggle={toggleVisibility}
                    />
                  ) : (
                    appendIcon
                  )
                }
              />
            </>
          );
        }}
      />
    </div>
  );
};
